<script setup lang="ts">
const props = defineProps(["modelValue", "error", "clearable", "doNormalizeDate"]);
const emit = defineEmits(["update:modelValue"]);

// Force date to be local without any timezone conversion
const normalizeDate = (date: Date | string | null | undefined): Date | null => {
  if (!date) return null;

  let dateObj: Date;

  // Convert string to Date object if needed
  if (typeof date === "string") {
    // Handle ISO string like "2025-01-17T11:00:00.000Z"
    const parts = date.split(/[-T]/);
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; // Month is 0-indexed
    const day = parseInt(parts[2]);

    dateObj = new Date(year, month, day, 12, 0, 0, 0);
  } else if (date instanceof Date) {
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return null;
    }

    // Get the individual components using local methods
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    dateObj = new Date(year, month, day, 12, 0, 0, 0);
  } else {
    return null;
  }

  return dateObj;
};

const value = computed({
  get() {
    if (props.doNormalizeDate) {
      return props.modelValue;
    }
    return normalizeDate(props.modelValue);
  },
  set(value: Date | string | null) {
    if (value) {
      emit("update:modelValue", value);
    } else {
      emit("update:modelValue", null);
    }
  },
});

const datepicker = ref<any>(null);
</script>

<template>
  <VueDatePicker
    v-if="props.doNormalizeDate"
    ref="datepicker"
    v-model="value"
    :enable-time-picker="false"
    :auto-apply="true"
    :clearable="props.clearable ?? false"
    locale="fr"
    month-name-format="long"
    format="dd/MM/yyyy"
    v-bind="$attrs"
    :data-error="props.error"
  >
  </VueDatePicker>
  <VueDatePicker
    v-else
    ref="datepicker"
    v-model="value"
    :enable-time-picker="false"
    :auto-apply="true"
    :clearable="props.clearable ?? false"
    locale="fr"
    month-name-format="long"
    format="dd/MM/yyyy"
    utc="false"
    v-bind="$attrs"
    :data-error="props.error"
  >
  </VueDatePicker>
</template>

<style lang="scss">
.dp__input {
  text-align: left;
  padding-left: 29px;
  padding-right: 0;
}

.dp__clear_icon {
  padding-right: 12px;
}

input.dp__input::placeholder {
  color: var(--grey-medium) !important;
}

.dp__input_icon {
  top: 19px;
  color: var(--grey-medium);
}

.dp__main {
  &[data-error="true"] {
    .dp__input {
      border-color: var(--red-main);
    }
  }
}

.dp__input[readonly],
.dp__input[readonly]:hover,
.dp__input[readonly]:focus {
  @apply border-none text-primary-color h-[40px] cursor-default;
}
</style>
